import React from 'react'
import bindAll from 'lodash/bindAll'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import $ from 'jquery'
import { UilSearch, UilClock, UilClipboardAlt, UilVideo, UilFileGraph } from '@iconscout/react-unicons'
import FooterNew from '../../partials/FooterNew'
import HeaderNewClear from '../../partials/HeaderNewClear'
import Pagination from '../../partials/Pagination'
import imgNoResult from "../../../images/no-result-assess.png";
import Select from 'react-select'
import{
  assessmentFetchData,
  assessmentGetDetail,
  assessmentAddFilterPageNumber,
  assessmentAddFilterSearch,
  assessmentAddFilterTestType,
  assessmentAddFilterJobRole,
  assessmentAddFilterJobLevel,
  assessmentFetchDetail,
  assessmentClearFilterData
} from '../../../actions/assessments'

type Props = {
	assessments: List<Map<string, any>>,
	assessmentFilterData: Map<string, any>,
	assessmentFetchData: Function,
	assessmentGetDetail: Function,
	assessmentAddFilterPageNumber: Function,
	assessmentAddFilterSearch: Function,
	assessmentAddFilterTestType: Function,
	assessmentAddFilterJobRole: Function,
	assessmentAddFilterJobLevel: Function,
	assessmentFetchDetail: Function,
	assessmentClearFilterData:Function
};

class AssessmentIndex extends React.Component<Props>
{
	constructor(props){
		super(props)
		this.state = {
			disableResetFilters: true,
			showSearchResult:false
		};
		bindAll(this, [
			'handleFilterByRole',
			'handleFilterByLevel',
			'handleFilterByTestType',
			'handleSearch',
			'handleClickDetail',
			'handleResetFilters',
			'checkIfExistFilter'
		])
	}

	componentDidMount(){
		this.props.assessmentClearFilterData().then(() => {
			this.props.assessmentFetchData(this.props.assessmentFilterData)
		})
		window.scrollTo(0,0)
	}

	handleFilterByRole(e){
		const role = e.value
		const { assessmentAddFilterPageNumber, assessmentAddFilterJobRole, assessmentFilterData, assessmentFetchData } = this.props
		assessmentAddFilterPageNumber(1).then(() => {
			assessmentAddFilterJobRole(role).then(() => {
				assessmentFetchData(this.props.assessmentFilterData).then(() => {
					this.checkIfExistFilter()
				})
			})
		})
	}

	handleFilterByLevel(e){
		const level = e.map(option => option.value);
		const { assessmentAddFilterPageNumber, assessmentAddFilterJobLevel, assessmentFilterData, assessmentFetchData } = this.props
		assessmentAddFilterPageNumber(1).then(() => {
			assessmentAddFilterJobLevel(level).then(() => {
				assessmentFetchData(this.props.assessmentFilterData).then(() => {
					this.checkIfExistFilter()
				})
			})
		})
	}

	handleFilterByTestType(e){
		const testType = e.value
		const { assessmentAddFilterPageNumber, assessmentAddFilterTestType, assessmentFilterData, assessmentFetchData } = this.props
		assessmentAddFilterPageNumber(1).then(() => {
			assessmentAddFilterTestType(testType).then(() => {
				assessmentFetchData(this.props.assessmentFilterData).then(() => {
					this.checkIfExistFilter()
				})
			})
		})
	}

	handleSearch(e){
		const searchTerm = e.target.value
		const { assessmentAddFilterPageNumber, assessmentAddFilterSearch, assessmentFilterData, assessmentFetchData } = this.props
		assessmentAddFilterPageNumber(1).then(() => {
			assessmentAddFilterSearch(searchTerm).then(() => {
				assessmentFetchData(this.props.assessmentFilterData).then(() => {
					this.checkIfExistFilter()
				})
			})
		})
	}
	handleClickDetail(index, assessmentId){
		const { assessments, assessmentFetchDetail } = this.props
		let assessment = assessments.get(index).toJS()
		assessmentFetchDetail(assessment).then(()=>{
			this.props.history.push(`/assessments-and-interviews/${assessmentId}`)
		})
	}

	handleResetFilters(){
		const {assessmentClearFilterData, assessmentFetchData} = this.props
		assessmentClearFilterData().then(() => {
			this.setState({disableResetFilters: true, showSearchResult: false})
			assessmentFetchData(this.props.assessmentFilterData)
		})
	}

	checkIfExistFilter(){
		const { assessmentFilterData } = this.props
		const filter = assessmentFilterData.toJS()
		if(filter.search=='' && filter.test_type=='' && filter.job_role=='' && filter.job_level.length==0){
			this.setState({disableResetFilters: true, showSearchResult: false})
		}else{
			this.setState({disableResetFilters: false, showSearchResult: true})
		}
	}

	render(){
		const { 
			globalGetLanguages, 
			assessments, 
			assessmentFilterData, 
			assessmentFetchData,
			assessmentPagination,
			assessmentAddFilterSearch,
			assessmentAddFilterPageNumber
		} = this.props

		const jobLevelOptions =[
			{value: 'All Levels', label: 'All Levels'},
			{value: 'Fresh Graduates', label: 'Fresh Graduates'},
			{value: 'Officer', label: 'Officer/Entry Level'},
			{value: 'Supervisory Level', label: 'Supervisory Level'},
			{value: 'Managerial Level', label: 'Managerial Level'},
		]

		const jobRoleOptions = [
			{ value: 'All Roles', label: 'All Roles' },
			{ value: 'Sales', label: 'Sales' },
			{ value: 'People Operations', label: 'HR / People Operations' },
			{ value: 'Marketing', label: 'Marketing' },
			{ value: 'People', label: 'People' },
			{ value: 'Information Technology', label: 'Information Technology' }
		];

		const testTypeOptions = [
			{ value: 'All Types', label: 'All Types' },
			{ value: 'General', label: 'General' },
			{ value: 'Traits', label: 'Traits' },
			{ value: 'Competency', label: 'Competency' },
			{ value: 'General & Competency', label: 'General & Competency' },
			{ value: 'Traits & Competency', label: 'Traits & Competency' }
		];

		return (
		<div id='assessment'>
			<HeaderNewClear isOnStatusLogo="is-on" />
			<div className="section-red triangle-left" style={{position: 'relative',paddingTop: '120px'}}>
				<section className='flex-container relative' style={{zIndex: '2'}}>
					<div className="header-assess">
						<h1>100% Free Access and Ready to Use</h1>
						{/* <h4>100% Free Access and Ready to Use</h4> */}
						<p>Get instant access to a variety of assessments and interview tools designed to make your talent<br/>decision process easier and more effective. <strong>Ready whenever you are, wherever you are</strong>.</p>
					</div>
				</section>
			</div>
			<div className="container">
				<div className="search-assess">
					<input 
						type="text" 
						placeholder="Search" 
						onChange={(e) => {
							assessmentAddFilterSearch(e.target.value).then(()=>{
								this.setState({disableResetFilters: false})
							})
						}} 
						value={assessmentFilterData.get('search')}
						onKeyPress={(e) => e.key === 'Enter' && this.handleSearch(e)} />
					<button onClick={() => {assessmentFetchData(assessmentFilterData).then(() => {
					this.setState({disableResetFilters: false, showSearchResult: true})
				})}}><UilSearch /></button>
				</div>
				<div className="filter-assess">
					<div className="filter-by-role">
						<Select
							options={jobRoleOptions}
							value={jobRoleOptions.filter(opt => opt.value === assessmentFilterData.get('job_role'))}
							onChange={this.handleFilterByRole}
							placeholder="Job Role"
							isClearable={false}
							className="react-select-container-job-level"
  							classNamePrefix="react-select-job-level"
						/>
					</div>
					<div className="filter-by-level">
						<Select
							value={jobLevelOptions.filter(option=>assessmentFilterData.get('job_level').includes(option.value))}
							onChange={this.handleFilterByLevel}
							options={jobLevelOptions}
							placeholder={'Job Level'}
							isClearable={false}
							isMulti
							simpleValue={true}
							className="react-select-container-job-level"
  							classNamePrefix="react-select-job-level"
						/>
						
					</div>
					<div className="filter-by-test-type">
						<Select
							options={testTypeOptions}
							value={testTypeOptions.filter(option => option.value === assessmentFilterData.get('test_type'))}
							onChange={this.handleFilterByTestType}
							placeholder="Test Type"
							isClearable={false}
							className="react-select-container-job-level"
  							classNamePrefix="react-select-job-level"
						/>
					</div>
				</div>
				<div className="result-reset-filter">
					<span>{this.state.showSearchResult ? `Showing ${assessmentPagination.get('total')} result` : ``}</span>
					{
						!this.state.disableResetFilters && 
						<button onClick={this.handleResetFilters}>Reset All Filter</button>
					}
				</div>
			</div>
			<div className='container assessment-index section-white m-b-32'>
				<div className='card-container'>
					{
						assessments.map((assessment, index) => (
							<div key={index} className='assessment-card'>
								<h3>{assessment.get('title')}</h3>
								<div className="tag-container">
									{
										assessment.get('assessment_content') === 'Assessment' && <span className="tag-type assessment"><UilClipboardAlt size="18" />{assessment.get('assessment_type')}</span>
									}

									{
										assessment.get('assessment_content') === 'Interview' && <span className="tag-type interview"><UilVideo size="18" />{assessment.get('assessment_type')}</span>
									}
									{
										assessment.get('assessment_content') === 'combination' && <span className="tag-type assessinterview"><UilFileGraph size="18" />{assessment.get('assessment_type')}</span>
									}
									{/* <span className="tag-type assessinterview"><UilFileGraph size="18" />{assessment.get('assessment_type')}</span> */}
									<span className="tag-time"><UilClock size="18"/>{assessment.get('total_duration')/60} Mins</span>
								</div>
								<p>{assessment.get('description')}</p>
								<a className="btn-primary" onClick={() => this.handleClickDetail(index, assessment.get('id'))}>Details</a>
							</div>
						))
					}
				</div>
				{
					assessmentPagination.get('total') === 0 &&  <div className="no-result">
					<img src={imgNoResult} alt="No Results Found" />
					<h2>No Results Found</h2>
					<p>The search does not match the assessments & interviews listed.<br />Try searching with different keywords.</p>
				</div>
				}
				
				{
					assessmentPagination.get('total') > assessmentPagination.get('per_page') && (
						<div className='row pagination'>
							<Pagination
								pagination={assessmentPagination}
								fetchData={assessmentFetchData}
								filterData={assessmentFilterData}
								addPageNumber={assessmentAddFilterPageNumber} />
						</div>
					)
				}
			</div>
			<FooterNew />
		</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return{ 
		globalGetLanguages:state.globalGetLanguages,
		assessments: state.assessments,
		assessmentFilterData: state.assessmentFilterData,
		assessmentPagination: state.assessmentPagination
	}
  
}

const mapDispatchToProps = (dispatch) => {
	return {
			assessmentFetchData: (filterData) => dispatch(assessmentFetchData(filterData)),
			assessmentGetDetail: (assessmentId, filterData) => dispatch(assessmentGetDetail(assessmentId, filterData)),
			assessmentAddFilterPageNumber: (pageNumber) => dispatch(assessmentAddFilterPageNumber(pageNumber)),
			assessmentAddFilterSearch: (searchTerm) => dispatch(assessmentAddFilterSearch(searchTerm)),
			assessmentAddFilterTestType: (testType) => dispatch(assessmentAddFilterTestType(testType)),
			assessmentAddFilterJobRole: (jobRole) => dispatch(assessmentAddFilterJobRole(jobRole)),
			assessmentAddFilterJobLevel: (jobLevel) => dispatch(assessmentAddFilterJobLevel(jobLevel)),
			assessmentFetchDetail: (assessment) => dispatch(assessmentFetchDetail(assessment)),
			assessmentClearFilterData: () => dispatch(assessmentClearFilterData())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentIndex)